export default __webpack_public_path__ + "static/media/more_options.3dc132b0.svg";